"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Preview = void 0;
var _react = _interopRequireDefault(require("react"));
require("./MediaInput.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//- React Imports

//- Style Imports

//- Type Imports

var Preview = _ref => {
  var mediaType = _ref.mediaType,
    previewUrl = _ref.previewUrl;
  if (mediaType === 'video') {
    return /*#__PURE__*/_react.default.createElement("video", {
      autoPlay: true,
      controls: true,
      loop: true,
      src: previewUrl
    });
  }
  return /*#__PURE__*/_react.default.createElement("img", {
    alt: "NFT Preview",
    src: previewUrl
  });
};
exports.Preview = Preview;
//# sourceMappingURL=Preview.js.map